import LegalPage, { LegalSection, LegalList } from "@/components/marketing/LegalPage";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" updated="July 2026" testid="privacy-page">
      <LegalSection title="1. Information Guinep Seed may collect">
        <p>When you use Guinep Seed, we may collect:</p>
        <LegalList
          items={[
            "Account information, such as your name, email address, and phone number if you provide it",
            "Business information, such as your business name and location",
            "The service information, pricing, and policies you add to your page",
            "Now updates you publish",
            "Enquiry information clients send through your page",
            "Basic usage and activity information, such as how your page is used",
          ]}
        />
      </LegalSection>

      <LegalSection title="2. How information is used">
        <p>We use this information to:</p>
        <LegalList
          items={[
            "Provide and operate the Guinep Seed service",
            "Create and display your business page",
            "Process and deliver enquiries",
            "Improve the service",
            "Support you when you need help",
            "Maintain the security of the platform",
            "Communicate important service updates",
          ]}
        />
      </LegalSection>

      <LegalSection title="3. Public business page information">
        <p>
          Anything you choose to publish on your Guinep Seed page may be visible publicly. This can
          include your business name, services, starting prices, policies, availability or Now
          updates, and the business contact details you provide for clients.
        </p>
        <p>
          Please only publish information you are comfortable sharing with anyone who visits your
          page.
        </p>
      </LegalSection>

      <LegalSection title="4. WhatsApp handoff">
        <p>
          Guinep Seed may help prepare or pass enquiry information into WhatsApp so a conversation
          can continue there.
        </p>
        <p>
          Once you or a client continue into WhatsApp, that interaction is also subject to WhatsApp
          and Meta's own privacy practices, which are separate from this policy.
        </p>
      </LegalSection>

      <LegalSection title="5. Activity insights">
        <p>
          Guinep Seed may collect simple activity information, such as page visits, link clicks, and
          enquiry activity, so business owners can see how their page is being used.
        </p>
        <p>We do not provide advanced tracking or behavioural analytics.</p>
      </LegalSection>

      <LegalSection title="6. Data sharing">
        <p>Guinep Seed does not sell personal information.</p>
        <p>Information may only be shared where needed to:</p>
        <LegalList
          items={[
            "Operate the service",
            "Work with necessary service providers who help us run Guinep Seed",
            "Comply with legal obligations",
            "Protect the platform or its users",
          ]}
        />
      </LegalSection>

      <LegalSection title="7. Data security">
        <p>
          We use reasonable safeguards to protect the information we hold. No online service can
          guarantee complete security, but we work to keep your information safe and limit access to
          it.
        </p>
      </LegalSection>

      <LegalSection title="8. Data retention">
        <p>
          We keep your information while your account is active. Some information may be retained
          for a reasonable period afterward where needed for legal, operational, or security
          purposes.
        </p>
      </LegalSection>

      <LegalSection title="9. Your choices and rights">
        <p>You can:</p>
        <LegalList
          items={[
            "View and edit the information on your business page at any time",
            "Ask us to access, correct, or delete your personal information",
            "Close your account if you no longer wish to use Guinep Seed",
          ]}
        />
        <p>
          To make any of these requests, contact us at{" "}
          <a
            href="mailto:hello@guinepseed.com"
            data-testid="privacy-contact-email-link"
            className="font-medium text-guinep-mid underline underline-offset-4 transition-colors hover:text-guinep-deep"
          >
            hello@guinepseed.com
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection title="10. Changes to this policy">
        <p>
          If we update this policy, we will post the new version on this page and update the date
          above. If a change is significant, we will do our best to let you know directly.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
